import React, { ReactElement, useMemo } from "react";

import { Video } from "./components";
import getVideo from "./getVideo";

export type Props = {
  readonly isCorrect: boolean;
  readonly shouldPlayVideo: boolean;
  readonly onEnded: () => void;
};

const ReactionVideo = ({
  isCorrect,
  shouldPlayVideo,
  onEnded,
}: Props): ReactElement | null => {
  const src = useMemo(
    () => (shouldPlayVideo ? getVideo(isCorrect) : null),
    [isCorrect, shouldPlayVideo]
  );

  if (!src) return null;

  return <Video src={src} onEnded={onEnded} />;
};

export default ReactionVideo;
